import style from "./style.module.scss";
import Logo from "../logo";
import { Username, LoginButton } from "../../../security";

function SimpleHeader() {
  return (
    <div className={style.header}>
      <Logo title="Retour à l'accueil" />
      <div className={style.right}>
        <Username />
        <LoginButton />
      </div>
    </div>
  );
}

export default SimpleHeader;
